<template>

    <section>
        
        <superadmin></superadmin>
        <!-- <superadmin v-if="isSuperadmin"></superadmin> -->

        <!-- <user v-else></user> -->

    </section>

</template>

<script>

import superadmin from "./includes/superadmin";

import user from "./includes/user";

export default {

    components: { superadmin, user },

    computed: {

        isSuperadmin() {
            
            // return false;

            return this.$store.getters["Auth/hasRole"]("superadmin")
        
        }

    }

}

</script>



// WEBPACK FOOTER //
// src/components/pages/Users/list-new/index.vue